// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
// import MessageIcon from '@material-ui/icons/Message';
import AddIcon from '@material-ui/icons/Add';
import OpenIcon from '@material-ui/icons/ArrowForward';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';

import * as coreSelectors from '../core/selectors';
import * as serviceActions from './actions';
import * as serviceSelectors from './selectors';
import * as accountSelectors from '../account/selectors';

import * as phoneActions from '../phone/actions';
import { USER_ACCOUNT_ROLE_KEYS } from 'constants/account.roles.constants';
import { canAccessBlockedContacts } from 'utils';

const styles = theme => ({
});

/*
 * Dialog when an email or phone number is clicked.  
 */
class ContactLink extends Component {

  closeDialog = () => {
    this.props.setContactLinkOpen(false);
  }

  createContact = () => {
    if (this.props.contactLink.type === 'EMAIL') {
      this.props.setContactLinkOpen(false);
      this.props.newContact(undefined, this.props.contactLink.value);
    }
    if (this.props.contactLink.type === 'PHONE') {
      this.props.setContactLinkOpen(false);
      this.props.newContact(this.props.contactLink.value);
    }
  }

  openContact = () => {
    this.props.setContactLinkOpen(false);
    this.props.openContact(this.props.contactLinkContacts[0]);
  }
  
  addToContact = () => {
    this.props.setContactLinkOpen(false);
    this.props.setActivityDetailOpen(false);
    this.props.setContactLinkOpen(false);
    this.props.setAddContactLink(this.props.contactLink);
    this.props.history.push('/contacts');
  }
  
  
  searchContacts = () => {
    this.props.setContactLinkOpen(false);
    this.props.setActivityDetailOpen(false);
    this.props.history.push('/contacts');
    this.props.setContactsSearchText(this.props.contactLink.value);
  }

  callNumber = () => {
    this.props.setContactLinkOpen(false);
    let outdialDigits = this.props.contactLink.value.replace(/\D/g, '');
    if (outdialDigits.length === 10) {
      this.props.setOutdialNumber('+1' + outdialDigits);
    } else {
      this.props.setOutdialNumber(this.props.contactLink.value);
    }
    this.props.setPhoneOpen(true);
  }
  
  textNumber = () => {
    this.props.setContactLinkOpen(false);
    let outdialDigits = this.props.contactLink.value.replace(/\D/g, '');
    if (outdialDigits.length === 10) {
      this.props.openSendText('+1' + outdialDigits);
    } else {
      this.props.openSendText(this.props.contactLink.value);
    }
  }

  blockOrUnblockNumber = () => {
    this.props.setContactLinkOpen(false);
    const formattedNumber = this.getPhoneNumberWithCountryCode(this.props.contactLink.value) 
    if(!this.props.blockNumbersAccount.find(item => item.phoneNumber === formattedNumber)){
      this.props.blockPhoneNumber(this.props.message.accountId, formattedNumber);
    }else{
      this.props.unblockPhoneNumber(this.props.message.accountId, formattedNumber, null);
    }
  }
  
  openEmail = () => {
    this.props.setContactLinkOpen(false);
    window.open('mailto:' + this.props.contactLink.value, '_blank');
  }

  checkAvailableNumbers = () => {
    return this.props.user.patchNumbers.length > 0;
  }

  checkGrassHopper = () => {
    return (this.props.user?.userAccountRoles?.filter(role => role.userRoleKey.includes(USER_ACCOUNT_ROLE_KEYS.GRASSHOPPER)).length > 0);
  }
  
  getPhoneNumberWithCountryCode(number){
    // Remove any non-digits
    const cleaned = number.replace(/\D/g,'')
    // Check if it already has a country code
    const hasCountryCode = number.startsWith("+")
    if(hasCountryCode){
      return `+${cleaned}`
    } 
    // Assume the country code is US/Canada
    else {
      return `+1${cleaned}`
    }
  }
  
  render() {
    // eslint-disable-next-line
    const { contactLink, contactLinkContacts,
            contactLinkOpen, contactLinkMenuAnchor,
            blockNumbersAccount,
            activityDetailOpen, message } = this.props;
    let menuItems=[];
    if (contactLink.type === 'EMAIL') {
      menuItems.push(
        <MuiCore.MenuItem key='1' onClick={this.openEmail}>
          <MuiCore.ListItemIcon>
            <EmailIcon/>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Email <b>{contactLink.value}</b>
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);
    }
    if (contactLink.type === 'PHONE') {
      if(!this.checkGrassHopper() && this.checkAvailableNumbers()){
        menuItems.push(
          <MuiCore.MenuItem key='2' onClick={this.callNumber}>
          <MuiCore.ListItemIcon>
            <PhoneIcon/>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Call <b>{contactLink.value}</b>
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);
      }
      // menuItems.push(
      //   <MuiCore.MenuItem key='7' onClick={this.textNumber}>
      //     <MuiCore.ListItemIcon>
      //       <MessageIcon/>
      //     </MuiCore.ListItemIcon>
      //     <MuiCore.ListItemText>
      //       Text <b>{contactLink.value}</b>
      //     </MuiCore.ListItemText>
      //   </MuiCore.MenuItem>);
      if(activityDetailOpen && message.accountId !== undefined && canAccessBlockedContacts(this.props.user, message.accountId)){
        menuItems.push(
          <MuiCore.MenuItem key='8' onClick={this.blockOrUnblockNumber}>
            <MuiCore.ListItemIcon>
              <BlockIcon/>
            </MuiCore.ListItemIcon>
            {!blockNumbersAccount.find(item => item.phoneNumber === this.getPhoneNumberWithCountryCode(contactLink.value)) ?
            <MuiCore.ListItemText>
              Block <b>{contactLink.value}</b>
            </MuiCore.ListItemText> : 
            <MuiCore.ListItemText>
              Unblock <b>{contactLink.value}</b>
            </MuiCore.ListItemText> 
            }
          </MuiCore.MenuItem>);
      }
    }

    let matches = (contactLinkContacts || []).length;
    if (matches === 1 && (window.location.href.match(/[^/]+$/) === null || window.location.href.match(/[^/]+$/)[0] !== 'contacts')) {
      menuItems.push(
        <MuiCore.MenuItem key='5' onClick={this.openContact}>
          <MuiCore.ListItemIcon>
            <MuiCore.Badge badgeContent={<OpenIcon color='secondary' fontSize='small'/>}>
              <PersonIcon/>
            </MuiCore.Badge>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Open Contact <b>{contactLinkContacts[0].displayName}</b>
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);

    }
    if (matches > 1 && (window.location.href.match(/[^/]+$/) === null || window.location.href.match(/[^/]+$/)[0] !== 'contacts')) {
      menuItems.push(
        <MuiCore.MenuItem key='6' onClick={this.searchContacts}>
          <MuiCore.ListItemIcon>
            <MuiCore.Badge badgeContent={<SearchIcon color='secondary' fontSize='small'/>}>
              <PeopleIcon/>
            </MuiCore.Badge>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Search Multiple Contact Matches
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);
    }
    
    if(window.location.href.match(/[^/]+$/) === null || window.location.href.match(/[^/]+$/)[0] !== 'contacts'){
      menuItems.push(
        <MuiCore.MenuItem key='3' onClick={this.createContact}>
          <MuiCore.ListItemIcon>
            <MuiCore.Badge badgeContent={<AddIcon color='secondary' fontSize='small'/>}>
              <PersonIcon/>
            </MuiCore.Badge>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Create Contact
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);
    }
    
    if(window.location.href.match(/[^/]+$/) === null || window.location.href.match(/[^/]+$/)[0] !== 'contacts'){
      menuItems.push(
        <MuiCore.MenuItem key='4' onClick={this.addToContact}>
          <MuiCore.ListItemIcon>
            <MuiCore.Badge badgeContent={<EditIcon color='secondary' fontSize='small'/>}>
              <PersonIcon/>
            </MuiCore.Badge>
          </MuiCore.ListItemIcon>
          <MuiCore.ListItemText>
            Add To Contact
          </MuiCore.ListItemText>
        </MuiCore.MenuItem>);
    }

    return (
      <React.Fragment>
        <MuiCore.Popover anchorEl={contactLinkMenuAnchor}
                         open={contactLinkOpen}
                         anchorOrigin={{ horizontal: 'right',
                                         vertical: 'top'}}
                         transformOrigin = {{
                           vertical : 'top',
                           horizontal : 'left',
                         }}
                         onClose={() => this.props.setContactLinkOpen(false)}>
          <MuiCore.MenuList>
            {menuItems}
          </MuiCore.MenuList>
        </MuiCore.Popover>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    contactLink : serviceSelectors.getContactLink(state),
    contactLinkContacts : serviceSelectors.getContactLinkContacts(state),
    contactLinkOpen : serviceSelectors.getContactLinkOpen(state),
    contactLinkMenuAnchor : serviceSelectors.getContactLinkMenuAnchor(state),
    filterType : serviceSelectors.getFilterType(state),
    accountId: accountSelectors.getAccountId(state),
    blockNumbersAccount: serviceSelectors.getBlockNumbersByAccount(state),
    activityDetailOpen : serviceSelectors.getActivityDetailOpen(state),
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  setContactLinkOpen : serviceActions.setContactLinkOpen,
  setContactsSearchText : serviceActions.setContactsSearchText,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  newContact : serviceActions.newContact,
  openContact : serviceActions.openContact,
  setPhoneOpen : phoneActions.setPhoneOpen,
  setOutdialNumber : phoneActions.setOutdialNumber,
  setAddContactLink : serviceActions.setAddContactLink,
  setSendTextOpen : serviceActions.setSendTextOpen,
  openSendText : serviceActions.openSendText,
  blockPhoneNumber: serviceActions.blockPhoneNumber,
  unblockPhoneNumber: serviceActions.unblockPhoneNumber,
  getBlockNumbersByAccount:serviceActions.blockNumbersByAccount,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactLink)));
